﻿import Vue from 'vue';
import basketMixin from '../core/basket'
import wishlistMixin from '../core/wishlist'
import utils from '../core/core'

// components
import productSlider from '../components/product-slider'
import productAutocomplete from '../components/product-autocomplete'

Vue.component('product-slider', productSlider);
Vue.component('product-autocomplete', productAutocomplete);

//import quantitySelector from '../components/quantity-selector.js'
//Vue.component('quantity-selector', quantitySelector);

var mainVM = new Vue({
    mixins: [basketMixin, wishlistMixin],
    el: '#mainApp'
});

window.utils = utils;

$(document).ready(function () {
    $(document).on("click", "[data-href]", function (event) {
        location.href = $(this).attr('data-href');
    });
});

////// test

//import Web3 from "web3";
//import Web3Modal from "web3modal";
//import WalletConnectProvider from "@walletconnect/web3-provider";

//const providerOptions = {
//    /* See Provider Options Section */
//};

//const web3Modal = new Web3Modal({
//    network: "mainnet", // optional
//    cacheProvider: true, // optional
//    providerOptions // required
//});

//const provider = await web3Modal.connect();

//const web3 = new Web3(provider);